// Presentation helpers only: WordPress and the API remain the access authorities.
const ACCOUNT = "https://staging.sofmat.it/il-tuo-spazio/";

export function sofmatCompanyId(tenant) {
  const id = tenant?.sofmat_company_id;
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}

export function portalLinks(tenant) {
  const company = sofmatCompanyId(tenant);
  const link = (base, view) => {
    const url = new URL(base);
    url.searchParams.set("sf_view", view);
    if (company !== null) url.searchParams.set("sf_company", String(company));
    return url.toString();
  };
  return {
    account: link(ACCOUNT, "home"),
    workshop: link("https://workshop.sofmat.it/", "workshop"),
    supplyhub: link("https://supplyhub.sofmat.it/", "supplyhub"),
    academy: link("https://academy.sofmat.it/", "academy"),
    messages: link(ACCOUNT, "messages"),
    support: link(ACCOUNT, "support"),
    profile: link(ACCOUNT, "profile"),
    subscription: link(ACCOUNT, "subscription"),
    team: link(ACCOUNT, "team"),
    quoteos: link(ACCOUNT, "quoteos"),
  };
}

export const SOFMAT_SPACES = [
  { key: "account", label: "Il tuo spazio", description: "Azienda, team e abbonamento" },
  { key: "workshop", label: "Workshop", description: "Community e rete produttiva" },
  { key: "supplyhub", label: "SupplyHub", description: "Fornitori e condizioni commerciali" },
  { key: "academy", label: "Academy", description: "Corsi e percorsi pratici" },
  { key: "quoteos", label: "QuoteOS", description: "Preventivazione industriale" },
];

const ROOT_PAGES = [
  ["/dashboard", "Dashboard", "dashboard"],
  ["/customers", "Clienti", "customers"],
  ["/rfqs", "Richieste", "rfqs"],
  ["/quotes", "Preventivi", "quotes"],
  ["/reader-queue", "Letture dei disegni", "reader-queue"],
  ["/operations/archive", "Archivio riservato", "operational-archive"],
  ["/config", "Configurazione costi", "config"],
  ["/price-lists", "Listini e costi", "price-lists"],
  ["/machines", "Parco macchine", "machines"],
  ["/billing", "Piano e fatturazione", "billing"],
  ["/users", "Utenti e ruoli", "users"],
  ["/audit", "Registro attività", "audit"],
  ["/settings", "Impostazioni azienda", "settings"],
  ["/collaudo-lettore", "Collaudo lettore", "collaudo-lettore"],
  ["/knowledge", "Conoscenza interna", "knowledge"],
];

function context(label, active, parent = null) {
  const crumbs = label === "Dashboard" ? [{ label }] : [{ label: "Dashboard", to: "/dashboard" }];
  if (parent) crumbs.push({ label: parent.label, to: parent.to });
  if (label !== "Dashboard") crumbs.push({ label });
  return { label, active, crumbs, backTo: parent?.to || "/dashboard", isDetail: !!parent };
}

export function pageContext(pathname) {
  const path = (typeof pathname === "string" ? pathname : "/dashboard").replace(/\/+$/, "") || "/dashboard";
  const root = ROOT_PAGES.find(([to]) => path === to);
  if (root) return context(root[1], root[2]);
  const rfqs = { label: "Richieste", to: "/rfqs" };
  const quotes = { label: "Preventivi", to: "/quotes" };
  const readings = { label: "Letture dei disegni", to: "/reader-queue" };
  if (path === "/rfqs/new") return context("Nuovo preventivo", "rfqs", rfqs);
  if (path === "/rfqs/import") return context("Importa richieste", "rfqs", rfqs);
  if (/^\/rfqs\/[^/]+\/reader-review\/[^/]+$/.test(path)) return context("Verifica del disegno", "reader-queue", readings);
  if (/^\/rfqs\/[^/]+$/.test(path)) return context("Dettaglio richiesta", "rfqs", rfqs);
  if (/^\/quote-preparation\/[^/]+$/.test(path)) return { ...context("Preparazione preventivo", "quotes", quotes), hideMobileDock: true };
  if (/^\/quotes\/reader\/[^/]+$/.test(path)) return { ...context("Preventivo dal disegno", "quotes", quotes), hideMobileDock: true };
  if (/^\/quotes\/[^/]+$/.test(path)) return context("Dettaglio preventivo", "quotes", quotes);
  if (/^\/reader-result\/[^/]+$/.test(path)) return context("Revisione tecnica", "reader-queue", readings);
  if (/^\/knowledge\/case\/[^/]+$/.test(path)) return context("Caso tecnico interno", "knowledge", { label: "Conoscenza interna", to: "/knowledge" });
  if (/^\/pdf-jobs\/[^/]+\/diagnostics$/.test(path)) return context("Diagnostica del disegno", "reader-queue", readings);
  if (/^\/pdf-jobs\/[^/]+\/verify$/.test(path)) return context("Verifica del disegno", "reader-queue", readings);
  if (/^\/pdf-jobs\/[^/]+\/expert$/.test(path)) return context("Revisione esperta", "reader-queue", readings);
  if (path === "/calibration") return context("Calibrazione officina", "config", { label: "Configurazione costi", to: "/config" });
  if (/^\/calibration\/[^/]+$/.test(path)) return context("Caso di calibrazione", "config", { label: "Configurazione costi", to: "/config" });
  const labs = { "/beta03": "Verifica consegna", "/p05": "Prova tecnica", "/spike-p1": "Laboratorio tecnico", "/verification-queue": "Coda verifiche" };
  if (labs[path]) return context(labs[path], "reader-queue", readings);
  return context("Pagina QuoteOS", "", null);
}

export function roleLabel(role) {
  return ({ owner: "Responsabile", admin: "Amministratore", estimator: "Preventivista", sales: "Commerciale", viewer: "Sola lettura" })[role] || "Utente";
}
